import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { twMerge } from 'tailwind-merge';
import { faPen } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { IconButton } from '@components/main-components/icon-buttons/IconButton';

export const ProfileImageEditButton = ({
  onClick,
  className,
}: {
  onClick: () => void;
  className?: string;
}) => {
  return (
    <IconButton
      className={twMerge(
        className,
        '!bg-white opacity-0 focus:!bg-white group-hover:opacity-70 hover:text-base900 hover:!opacity-100',
      )}
      icon={<FontAwesomeIcon icon={faPen} />}
      onClick={onClick}
      size={28}
      iconSize={16}
    />
  );
};
